var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-card",
        { staticClass: "ma-2" },
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("home")]),
              _vm._v(" Quick-Load New Hotel\n            "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-container", [
                _c(
                  "fieldset",
                  [
                    _c("legend", [_vm._v("Questionnaire Information")]),
                    _vm._v(" "),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Address 1:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Address 1",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.address1,
                                callback: function ($$v) {
                                  _vm.address1 = $$v
                                },
                                expression: "address1",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Address 2:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Address 2",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.address2,
                                callback: function ($$v) {
                                  _vm.address2 = $$v
                                },
                                expression: "address2",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("City*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.city
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(_vm._s(_vm.validation.messages.city)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "City", outlined: "", dense: "" },
                              model: {
                                value: _vm.city,
                                callback: function ($$v) {
                                  _vm.city = $$v
                                },
                                expression: "city",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Post Code:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Post Code",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.postCode,
                                callback: function ($$v) {
                                  _vm.postCode = $$v
                                },
                                expression: "postCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Postal Address:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Postal Address",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.postalAddress,
                                callback: function ($$v) {
                                  _vm.postalAddress = $$v
                                },
                                expression: "postalAddress",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Website*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.website
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.website)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Website",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.website,
                                callback: function ($$v) {
                                  _vm.website = $$v
                                },
                                expression: "website",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Main Contact Name*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.keyContact
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.keyContact)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Main Contact Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.keyContact,
                                callback: function ($$v) {
                                  _vm.keyContact = $$v
                                },
                                expression: "keyContact",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Marketing Contact Name:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Marketing Contact Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.marketingName,
                                callback: function ($$v) {
                                  _vm.marketingName = $$v
                                },
                                expression: "marketingName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Marketing Email:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Marketing Email",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.marketingEmail,
                                callback: function ($$v) {
                                  _vm.marketingEmail = $$v
                                },
                                expression: "marketingEmail",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Owner*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.owner
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(_vm._s(_vm.validation.messages.owner)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Owner Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.owner,
                                callback: function ($$v) {
                                  _vm.owner = $$v
                                },
                                expression: "owner",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-label", [
                              _vm._v("GPS Location (Latitude, Longitude) *:"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.googleMapPosition
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.googleMapPosition
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "GPS", outlined: "", dense: "" },
                              model: {
                                value: _vm.googleMapPosition,
                                callback: function ($$v) {
                                  _vm.googleMapPosition = $$v
                                },
                                expression: "googleMapPosition",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Detailed directions*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.detailedDirections
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.detailedDirections
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-textarea", {
                              attrs: { dense: "" },
                              model: {
                                value: _vm.detailedDirections,
                                callback: function ($$v) {
                                  _vm.detailedDirections = $$v
                                },
                                expression: "detailedDirections",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-label", [
                              _vm._v("When Did Property First Open?"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-textarea", {
                              attrs: { dense: "" },
                              model: {
                                value: _vm.dateOpened,
                                callback: function ($$v) {
                                  _vm.dateOpened = $$v
                                },
                                expression: "dateOpened",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Type of Property*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.propertyType
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.propertyType)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                label: "Property Type",
                                items: _vm.propertyTypes,
                                autocomplete: "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.propertyType,
                                callback: function ($$v) {
                                  _vm.propertyType = $$v
                                },
                                expression: "propertyType",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Total No. Rooms:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Total No. Rooms",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.totalNumRooms,
                                callback: function ($$v) {
                                  _vm.totalNumRooms = $$v
                                },
                                expression: "totalNumRooms",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Rates:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-col", { attrs: { cols: "8" } }, [
                          _vm._v("Room types should be loaded later"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Channel Manager:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("ies-input-channel-manager-names", {
                              attrs: { field: _vm.channelManagerField },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Currency*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.currencyKey
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.currencyKey)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                label: "Currency",
                                items: _vm.currencies,
                                autocomplete: "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.currencyKey,
                                callback: function ($$v) {
                                  _vm.currencyKey = $$v
                                },
                                expression: "currencyKey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Default Rate Basis*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "Default Rate Basis",
                                items: _vm.rateBasisOptions,
                                autocomplete: "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.defaultRateBasis,
                                callback: function ($$v) {
                                  _vm.defaultRateBasis = $$v
                                },
                                expression: "defaultRateBasis",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Optional Extras:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c("v-textarea", {
                              attrs: { dense: "" },
                              model: {
                                value: _vm.rateOptionalExtras,
                                callback: function ($$v) {
                                  _vm.rateOptionalExtras = $$v
                                },
                                expression: "rateOptionalExtras",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Accepted Credit Cards*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c("v-col", { attrs: { cols: "3" } }, [
                                  _c("label", [
                                    _vm._v("Mastercard "),
                                    _c("img", {
                                      staticClass: "cc-logo",
                                      attrs: {
                                        src: "/images/logos/mastercard.svg",
                                        alt: "MasterCard",
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "9" } },
                                  [
                                    _c("v-checkbox", {
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value: _vm.acceptsMastercard,
                                        callback: function ($$v) {
                                          _vm.acceptsMastercard = $$v
                                        },
                                        expression: "acceptsMastercard",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-col", { attrs: { cols: "3" } }, [
                                  _c("label", [
                                    _vm._v("Visa "),
                                    _c("img", {
                                      staticClass: "cc-logo",
                                      attrs: {
                                        src: "/images/logos/visa.png",
                                        alt: "Visa",
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "9" } },
                                  [
                                    _c("v-checkbox", {
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value: _vm.acceptsVisa,
                                        callback: function ($$v) {
                                          _vm.acceptsVisa = $$v
                                        },
                                        expression: "acceptsVisa",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-col", { attrs: { cols: "3" } }, [
                                  _c("label", [
                                    _vm._v("Amex "),
                                    _c("img", {
                                      staticClass: "cc-logo",
                                      attrs: {
                                        src: "/images/logos/american-express.svg",
                                        alt: "American Express",
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "9" } },
                                  [
                                    _c("v-checkbox", {
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value: _vm.acceptsAmex,
                                        callback: function ($$v) {
                                          _vm.acceptsAmex = $$v
                                        },
                                        expression: "acceptsAmex",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Rate Types and Policies should be loaded later"
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Nearest Airport 1 (km)*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.airportName1
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.airportName1)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Name", outlined: "", dense: "" },
                              model: {
                                value: _vm.airportName1,
                                callback: function ($$v) {
                                  _vm.airportName1 = $$v
                                },
                                expression: "airportName1",
                              },
                            }),
                            _vm._v(" "),
                            _vm.validation.messages.airportDistance1
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.airportDistance1
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Distance",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.airportDistance1,
                                callback: function ($$v) {
                                  _vm.airportDistance1 = $$v
                                },
                                expression: "airportDistance1",
                              },
                            }),
                            _vm._v(" "),
                            _vm.validation.messages.airportCode1
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.airportCode1)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Code", outlined: "", dense: "" },
                              model: {
                                value: _vm.airportCode1,
                                callback: function ($$v) {
                                  _vm.airportCode1 = $$v
                                },
                                expression: "airportCode1",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Nearest Airport 2 (km)*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.airportName2
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.airportName2)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Name", outlined: "", dense: "" },
                              model: {
                                value: _vm.airportName2,
                                callback: function ($$v) {
                                  _vm.airportName2 = $$v
                                },
                                expression: "airportName2",
                              },
                            }),
                            _vm._v(" "),
                            _vm.validation.messages.airportDistance2
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.airportDistance2
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Distance",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.airportDistance2,
                                callback: function ($$v) {
                                  _vm.airportDistance2 = $$v
                                },
                                expression: "airportDistance2",
                              },
                            }),
                            _vm._v(" "),
                            _vm.validation.messages.airportCode2
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.validation.messages.airportCode2)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Code", outlined: "", dense: "" },
                              model: {
                                value: _vm.airportCode2,
                                callback: function ($$v) {
                                  _vm.airportCode2 = $$v
                                },
                                expression: "airportCode2",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-label", [
                              _vm._v("Nearest Restaurant (km)*:"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.restaurantDistance
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.restaurantDistance
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Distance",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.restaurantDistance,
                                callback: function ($$v) {
                                  _vm.restaurantDistance = $$v
                                },
                                expression: "restaurantDistance",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Nearest Shop (km)*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.shopsDistance
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.shopsDistance
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Distance",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.shopsDistance,
                                callback: function ($$v) {
                                  _vm.shopsDistance = $$v
                                },
                                expression: "shopsDistance",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Display Status*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.displayStatus
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.displayStatus
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                label: "Display Status",
                                items: _vm.displayStatuses,
                                autocomplete: "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.displayStatus,
                                callback: function ($$v) {
                                  _vm.displayStatus = $$v
                                },
                                expression: "displayStatus",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [_c("v-label", [_vm._v("Travel Operator*:")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.validation.messages.travelOperator
                              ? _c("div", { staticClass: "error-message" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validation.messages.travelOperator
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                label: "Travel Operator",
                                items: _vm.travelOperators,
                                autocomplete: "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.travelOperator,
                                callback: function ($$v) {
                                  _vm.travelOperator = $$v
                                },
                                expression: "travelOperator",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "lime",
                                on: {
                                  click: function ($event) {
                                    return _vm.save()
                                  },
                                },
                              },
                              [_vm._v("Update Hotel")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }